import { NotificationType, notificationService } from '../ui-services/notification.service';

/**
 * Toggle loading state while action is executing.
 * @param {import("vue").Ref<boolean>} loadingRef Loading ref.
 * @param {Function|null} action Action.
 * @param {Function|null} onError On error handler.
 * @param {Function|null} onFinally On finally handler.
 * @returns {Promise<any>}
 */
export async function toggleExecutionState(loadingRef, action = null, onError = null, onFinally = null) {
  if (loadingRef == null || typeof loadingRef.value !== 'boolean') {
    throw new Error('There is no loading state!');
  }

  try {
    // Ignore this eslint rule because vue ref value is needed to update via .value
    // eslint-disable-next-line no-param-reassign
    loadingRef.value = true;
    if (action) {
      return await action();
    }
  } catch (e) {
    // Automatically show a notification by default.
    if (onError == null) {
      const errorMessage = e.response?.data?.message;
      notificationService.notify({ message: errorMessage ?? e, type: NotificationType.error });
      throw e;
    } else {
      // An async onError must finish before `finally` resets the loading ref.
      await onError(e);
      throw e;
    }
  } finally {
    // Ignore this eslint rule because vue ref value is needed to update via .value
    // eslint-disable-next-line no-param-reassign
    loadingRef.value = false;
    if (onFinally != null) {
      onFinally();
    }
  }
}
